// angular
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../core/auth.service';
import { KlenicoMeService } from '../me.service';
@Component({
    selector: 'me-header',
    templateUrl: './me-header.component.html',
    styleUrls: ['./me-header.component.scss'],
})

export class MeHeaderComponent {
    
    constructor(
        public authService: AuthService,
        public router: Router,
        public meService: KlenicoMeService
    ) { }
}
